module.exports = __webpack_public_path__ + "static/img/over.bc38dc3e.png";